// SCRNITM#fx
export default [
  {
    name: 'Advertisement',
    path: '/ad',
    meta: {
      auth: false
    },
    component: () =>
      import(/* webpackChunkName: "no_show_ad" */ './Advertisement.vue')
  }
]
